/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import {vec3} from "gl-matrix"

export default
class Interpolator {
    protected _interPosition: vec3 = vec3.create();
    protected _interTarget: vec3 = vec3.create();

    protected _typeName: string = "AbstractInterpolator";

    constructor() {
    }

    public init(aStartFrame: { position: vec3, target: vec3 }): void {
        if (Object.getOwnPropertyNames(aStartFrame).length > 0) {
            vec3.copy(this._interPosition, aStartFrame.position);
            vec3.copy(this._interTarget, aStartFrame.target);
        }
    }

    public getPosition(): vec3 {
        return vec3.clone(this._interPosition);
    }

    public getTarget(): vec3 {
        return vec3.clone(this._interTarget);
    }

    public interpolate(aFrameA: any, aFrameB: any, aTimeDiff: number): {position: vec3, target: vec3} {
        return {position: vec3.create(), target: vec3.create()};
    }
}
